/**
 * The folder („Mappe“, S37, L2): on the net the recommendations („Empfehlungen“) stand above the
 * menu on the net, in a box of their own with their title. They are a menu like any other; the
 * business chooses which (`recommendationsMenu`), and swapping it puts the new one on the net at once
 * without freezing the main menu anew. The page has one head (the main menu's) and one legend at the
 * end, for both. Paper: the recommendations are printed on their own, as an insert (L3).
 */
import type { Allergen } from "./allergens.ts";
import type { PublishedMenu, PublishedSection, PublishedTexts } from "./card-web.ts";

/** The recommendations as frozen with the menu on the net. */
export interface PublishedLead {
  menu: string;
  title: string;
  subtitle: string;
  note: string;
  sections: PublishedSection[];
  legend: Allergen[];
  tagIcons?: Record<string, string>;
  /** The texts in further languages (S36); only when there are some. */
  texts?: PublishedTexts;
}

/** The recommendations out of a frozen menu of their own (`freezeMenu`). */
export function leadOf(p: PublishedMenu): PublishedLead {
  return { menu: p.menu, title: p.title, subtitle: p.subtitle, note: p.note, sections: p.sections, legend: p.legend, ...(p.tagIcons ? { tagIcons: p.tagIcons } : {}), ...(p.texts ? { texts: p.texts } : {}) };
}

/** Letters before numbers, numbers by their value: „a … n, 1 … 13“, as the catalogue has them. */
const byCode = (a: Allergen, b: Allergen) => {
  if (a.kind !== b.kind) return a.kind === "allergen" ? -1 : 1;
  const na = /^\d+$/.test(a.code);
  const nb = /^\d+$/.test(b.code);
  if (na !== nb) return na ? 1 : -1;
  return na ? Number(a.code) - Number(b.code) : a.code.localeCompare(b.code, "de");
};

/** One legend for the page: what the recommendations and the menu use, each code once. */
export function legendWithLead(legend: readonly Allergen[], lead: PublishedLead | undefined): Allergen[] {
  if (!lead) return [...legend];
  const all = new Map<string, Allergen>();
  for (const a of [...legend, ...lead.legend]) if (!all.has(a.code)) all.set(a.code, a);
  return [...all.values()].sort(byCode);
}
